import dayjs from "dayjs"
import { toast } from "sonner"

import { Image } from "@/components/ui"
import { ETypeNotification } from "@/modules/helpers/enum"
import { useNotificationAction } from "@/modules/helpers/hooks/shared/use-notification-action"
import { cn } from "@/modules/helpers/hooks/shared/utils"
import { parseNotificationTextToTokens, TextToken } from "@/modules/helpers/utils/notification"
import { Notification } from "@/modules/types"

export const NotificationItem = ({ data }: { data: Notification; index: number }) => {
  const { handleNotificationClick } = useNotificationAction()

  let thumbnail: string | undefined
  let title: string | undefined

  try {
    const anyAdditional =
      data?.additionalData && typeof data.additionalData === "string"
        ? JSON.parse(data.additionalData)
        : data.additionalData || {}

    thumbnail = anyAdditional?.campaign?.thumbnail || anyAdditional?.thumbnail
    title = anyAdditional?.title
  } catch {
    toast.error("Lỗi khi tải thông tin thông báo")
  }

  const { description, isHTML } = parseNotificationTextToTokens(data?.body || "")

  return (
    <div
      key={data?.id}
      onClick={() => handleNotificationClick(data)}
      className={cn(
        "px-4 py-3 border-b border-gray-100 cursor-pointer transition-colors active:bg-gray-50",
        {
          "bg-gray-50/50": !data?.isRead,
          "bg-blue-100": data?.type === ETypeNotification.INVITE_RECEIVE_SAMPLE
        }
      )}
    >
      <div className="flex gap-3 items-start">
        {/* Left: Thumbnail or Icon */}
        <div className="flex-shrink-0">
          <div className="w-16 h-16 rounded-lg overflow-hidden bg-gray-100">
            <Image src={thumbnail} alt="thumb" className="w-full h-full rounded-lg object-cover" />
          </div>
        </div>

        {/* Right: Content */}
        <div className="flex-1 min-w-0">
          {title && <h3 className="font-semibold text-sm text-primary-800 mb-1">{title}</h3>}
          {description && (
            <div className="text-xs text-gray-700 leading-relaxed mb-1.5 line-clamp-4">
              {isHTML ? (
                <div
                  dangerouslySetInnerHTML={{ __html: (description as string) || "" }}
                  className="[&_span.text-cyan-600]:text-cyan-600 [&_span.text-red-600]:text-red-600 [&_span.text-red-600]:font-semibold"
                />
              ) : (
                <p>
                  {(description as TextToken[]).map((token, i) => (
                    <span
                      key={i}
                      className={cn({
                        "text-cyan-600": token.type === "highlight",
                        "text-red-600 font-semibold": token.type === "percentage"
                      })}
                    >
                      {token.content}
                    </span>
                  ))}
                </p>
              )}
            </div>
          )}
          {data?.createdAt && (
            <p className="text-xss text-gray-600">
              {dayjs(data?.createdAt).format("HH:mm, DD/MM/YYYY")}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
